export default {"src":"/_next/static/media/logo.65e43529.svg","height":34,"width":157,"blurWidth":0,"blurHeight":0};